import { Component } from '@angular/core';
@Component({
  selector: 'empty-dashboard',
  template: '',
})
export class EmptyDashboardComponent {}



// WEBPACK FOOTER //
// ./src/app/main/empty-dashboard.component.ts